import {Component, OnInit} from '@angular/core';
import {LoginResponse, OidcSecurityService} from 'angular-auth-oidc-client';
import {BehaviorSubject} from 'rxjs';
import {Router} from '@angular/router';
import {AppSandboxService} from '../../app-sandbox.service';
import {map} from 'rxjs/operators';
import { ACCESS } from '../../tools/access';

@Component({
  selector: 'kyt-root',
  styleUrls: ['./app.container.scss'],
  template: `
    <kyt-header *ngIf="(isAuthenticated$ |async) && (userDetailsAvailable$ | async) && (userDetails$.getValue().status==='Active')"
      [user]="userDetails$ | async"
      (goToLanding)="goToLanding()"></kyt-header>
    <kyt-login *ngIf="(isAuthenticated$ | async) === false"
    (connexionRequested)="checkConnexionRequest($event)"></kyt-login>
    <kyt-not-allowed *ngIf="userDetails$.getValue()?.status==='Deactivated' || userDetails$.getValue()?.status==='' "></kyt-not-allowed>
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
      <p style="color:#fff;">Data is loading, please wait. </p>
    </ngx-spinner>
    <router-outlet></router-outlet>
  `
})
export class AppContainer implements OnInit {
  userDetails$ = this.sb.currentUser;
  isAuthenticated$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  hasLoggedOutFromKYT$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  userDetailsAvailable$ = this.sb.userDetailAvailable;
  access = ACCESS;
  constructor(private oidcSecurityService: OidcSecurityService,
    private router: Router, private sb: AppSandboxService,
) {
  }

  ngOnInit(): void {
    this.oidcSecurityService.checkAuth().pipe(
      map((auth: LoginResponse) => {
        sessionStorage.setItem('idToken', auth.idToken)
        return auth.isAuthenticated;
      })
    ).subscribe((auth) => {
      this.isAuthenticated$.next(auth);
    });
  }

  login(): void {
    this.oidcSecurityService.authorize();
  }

  logout(): void {
    this.router.navigate(['/logout']).then();
    this.hasLoggedOutFromKYT$.next(true);
  }

  goToLanding(): void {
    if (this.userDetailsAvailable$.getValue()){
        if (this.userDetails$.getValue().role === 'Armatis'){
          this.router.navigate(['/alerts-follow-up/cards']).then();
        }else if (this.userDetails$.getValue().role === 'BEMO'){
          this.router.navigate(['/alerts-follow-up/charges']).then();
        }else{
          this.router.navigate(['/kyt/card-alerts']).then();
        }
    }else{
      this.router.navigate(['/login']);
    }
  }

  checkConnexionRequest(userRequestConnexion: boolean): void {
    if (userRequestConnexion === true) {
      this.login();
    }
  }
}
